(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsPermission', rmsPermission);

    function rmsPermission() {
        return {
            restrict: 'E',
            controller: rmsPermissionCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/permissions/main',
            scope: {
                options: '=?',
                selectedUser: '=?',
                model: '=?',
                getModel: '=',
                selectorForm: '=?'
            }
        };
    }

    function rmsPermissionCtrl(PermissionService, $scope, lodash, $timeout) {
        var vm = this;
        this.$onInit = function() {
            vm.selectedItem = null;
            vm.showDescription = false;
            vm.service = new PermissionService();
            vm.service.initModel(vm.model);

            vm.onItemClick = function (item) {
                vm.selectedItem = item;
            };
            $timeout(function() {
                if (lodash.has(vm.options, 'trigger.on_load')) {
                    $scope.$emit(vm.options.trigger.on_load);
                }
            });

            vm.getModel = function (type) {
                if (type === 'entity-selector') {
                    return lodash.get(vm.options, 'entity_selector.model', {});
                }
                return vm.service.getModel();
            };

            $scope.$watch(function () {
                return vm.model;
            }, function () {
                vm.service.initModel(vm.model);
            });

            $scope.$watch(function() {
                return vm.options.permission_sections;
            }, function() {
                if (vm.options.permission_sections) {
                    vm.selectedItem = vm.options.permission_sections[0];
                } else {
                    vm.selectedItem = null;
                }
            });
        }
    }
})();